import type { Route } from 'fitify-ui-onboarding/src/types/routeTypes'

import { getRouteKey } from 'components/RoutePrefetch/RoutePrefetch.Utils'
import { ALL_IMAGES, DEFAULT_IMAGE_VARIANT } from 'data/images'
import type { ImageDefinition } from 'types/images'
import type { Funnel } from 'types/state'
import { type ImageParams, resolveImageParams } from 'utils/images'

const getRouteImagesDefinition = (
  routeKey: string,
  funnel: Funnel,
  variant: string
) => {
  const routeImagesDefinition = Object.entries(
    Object.entries(ALL_IMAGES[funnel]).find(([key]) => key === variant)?.[1] ||
      {}
  ).find(([key]) => key === routeKey)?.[1]

  if (routeImagesDefinition) {
    return routeImagesDefinition as Record<string, ImageDefinition>
  }
  return undefined
}

/**
 * Gets the image definitions for the given route and funnel. Images are resolved based on the route key,
 * which should match the top level key in the funnel-specific images definition.
 * Images are resolved from the selected variant definition. The `{{locale}}` and `{{theme}}` placeholders are
 * substituted with the given params; only images with complete srcSet entries resolved (no template placeholders) are returned.
 */
export const getRouteImages = (
  route: Route<string>,
  funnel: Funnel,
  variant: string = DEFAULT_IMAGE_VARIANT,
  params?: ImageParams
): ImageDefinition[] => {
  const routeKey = getRouteKey(route, funnel)

  if (routeKey) {
    const routeImagesDefinition = getRouteImagesDefinition(
      routeKey,
      funnel,
      variant
    )
    if (routeImagesDefinition) {
      return Object.values(routeImagesDefinition)
        .map((imageDefinition) => resolveImageParams(imageDefinition, params))
        .filter((imageDefinition) =>
          imageDefinition.srcSet.every((src) => !src.includes('{{'))
        )
    }
  }

  return []
}
